"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accruedInterestCalculationSchema = void 0;
var constants_1 = require("../../constants");
exports.accruedInterestCalculationSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    // TODO: temporarily disable required fields until DMP is hardened
    // required: [
    //   'typeCode',
    //   'endDate',
    //   'interestAmount',
    //   'adjustedDefaultInterestRatePercent',
    //   'numberOfDaysCount',
    //   'startDate',
    // ],
    properties: {
        typeCode: {
            type: 'integer',
            enum: Object.values(constants_1.AccruedInterestCalculationTypeCode),
            errorMessage: 'Should equate to a valid AccruedInterestCalculationTypeCode enum value',
        },
        endDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        interestAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        adjustedDefaultInterestRatePercent: {
            type: 'number',
            maximum: 99999999999,
            minimum: -99999999999,
            decimal: [15, 4],
            errorMessage: 'should be a decimal with up to 15 digits in total and 4 digits of precision',
        },
        numberOfDaysCount: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
        startDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
    },
};
